import { usePreferences } from '../contexts/PreferencesContext';
import { en } from './en';
import { de } from './de';
import { lv } from './lv';
import { ru } from './ru';
import { lt } from './lt';
import { et } from './et';
import { es } from './es';
import { pt } from './pt';
import { pl } from './pl';
import { no } from './no';
import { sl } from './sl';
import { sv } from './sv';
import { ro } from './ro';
import { nl } from './nl';
import { it } from './it';
import { fr } from './fr';
import { hr } from './hr';
import { SupportedLanguage } from '../lib/expenseTypeHelpers';

export type Translations = typeof en;

export const translations: Record<string, Translations> = {
    en,
    de,
    lv,
    ru,
    lt,
    et,
    es,
    pt,
    pl,
    no,
    sl,
    sv,
    ro,
    nl,
    it,
    fr,
    hr,
};

export function useTranslations() {
    const { preferences } = usePreferences();
    // Default to 'en' if preferences are not loaded or language not set
    const lang = (preferences?.language || 'en') as SupportedLanguage;

    // Get translations for language, fallback to 'en' if translation file doesn't exist
    const t = translations[lang] || en;

    return { t, language: lang };
}
